/**
 * Провайдери застосунку: кеш серверного стану, маршрути, повторний вхід поверх
 * сторінки і межа помилок над ними (support/RootBoundary.tsx). Спільне для main.tsx і тестів.
 */
import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ReloginHost } from '../features/relogin/ReloginHost.tsx';
import { onUnauthorized, platformKeys } from '../platform/api.ts';
import { trackFetchStarts } from '../platform/events.ts';
import { RootBoundary } from '../support/RootBoundary.tsx';
import type { createAppRouter } from './router.tsx';

export function App({
  queryClient,
  router,
}: {
  queryClient: QueryClient;
  router: ReturnType<typeof createAppRouter>;
}) {
  // Довідники кешуються цілком і лише в пам'яті вкладки (вимога Security S2 #336; SEC-008,
  // SEC-024): відповідь 401 — сесії більше немає, тож геть і їх (platform/references.ts).
  useEffect(
    () => onUnauthorized(() => queryClient.removeQueries({ queryKey: platformKeys.references })),
    [queryClient],
  );
  // Початок читань — для відлуння власної зміни (platform/events.ts).
  useEffect(() => trackFetchStarts(queryClient), [queryClient]);
  return (
    <RootBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {/* Повторний вхід поверх сторінки (UX-30): портал у body, поза прихованим #root. */}
        <ReloginHost />
      </QueryClientProvider>
    </RootBoundary>
  );
}
